<div class="w-full bg-cover bg-center bg-no-repeat z-0" [style]="style">
    <ng-content></ng-content>
</div>